import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader } from "../../../components/card/card";

export const AssetComponent = ({ readOnly, setValue, value }) => {
  const [inventories, setInventories] = useState([]);

  const addPart = () => {
    let copy = [...value];
    copy = [...copy, { component: "", description: "" }];
    setValue(copy);
  };

  const handlePartChange = (e, index) => {
    const name = e.target.name;
    let copy = [...value];
    copy[index][name] = e.target.value;

    setValue(copy);
  };

  const deletePart = (index) => {
    let copy = [...value];
    copy.splice(index, 1);
    setValue(copy);
  };

  const isSelectedInventory = (id) => {
    return value.some((p) => p.inventory_id == id);
  };

  return (
    <Card className="my-3">
      <CardHeader>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>Asset Components</div>
          <div>
            <button
              onClick={addPart}
              className="btn btn-sm btn-outline-theme"
              style={{ marginRight: "10px" }}
            >
              Add Component
            </button>
          </div>
        </div>
      </CardHeader>
      <CardBody>
        <table
          className={"responsive-table-full"}
          style={{
            width: "100%",
            borderCollapse: "separate",
            borderSpacing: ".5em 1em",
          }}
        >
          <thead>
            <tr>
              <th>Component</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {value.map((part, i) => (
              <tr key={i}>
                <td style={{ verticalAlign: "top" }}>
                  <input
                    className="form-control"
                    type="text"
                    name="component"
                    placeholder={"Component"}
                    onChange={(e) => handlePartChange(e, i)}
                    value={part.component}
                    readOnly={readOnly}
                  />
                </td>

                <td style={{ verticalAlign: "top" }}>
                  <input
                    className="form-control"
                    type="text"
                    name="description"
                    placeholder={"Description"}
                    onChange={(e) => handlePartChange(e, i)}
                    value={part.description}
                    readOnly={readOnly}
                  />
                </td>

                <td style={{ verticalAlign: "top" }}>
                  {!readOnly && (
                    <div
                      className="btn btn-danger"
                      onClick={() => {
                        deletePart(i);
                      }}
                    >
                      Delete
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </CardBody>
    </Card>
  );
};
